import React from "react";

const OfferItem = ({ offer }) => {
  return (
    <a
      href={offer.link}
      target="_blank"
      rel="noreferrer"
      className="w-full flex items-center gap-3 rounded-2xl px-4 py-3 mt-2 fade-in transition-colors hover:bg-white/[0.07]"
      style={{
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.07)",
      }}
    >
      <img
        src={offer.picture}
        alt={offer.name_short}
        className="w-[52px] h-[52px] rounded-lg object-cover flex-shrink-0"
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h2 className="semiBold text-white text-[15px] truncate">{offer.name_short}</h2>
          <span className="bg-light-blue text-white py-[1px] px-[10px] text-[11px] semiBold rounded-md flex-shrink-0">
            Free
          </span>
        </div>
        <p className="medium text-white/60 text-xs mt-0.5">{offer.adcopy}</p>
      </div>
    </a>
  );
};

export default OfferItem;
